import Model from "../Model";

export default class Order extends Model {
    get url() {
        return '/api/orders';
    }
}